"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIONS_PLACEOFBIRTH = exports.OPTIONS_ORICODES = exports.OPTIONS_BUILD = exports.OPTIONS_FACIALHAIR = exports.OPTIONS_SIDEBURNS = exports.OPTIONS_MUSTACHE = exports.OPTIONS_BEARD = exports.OPTIONS_COMPLEXION = exports.OPTIONS_HAIRSTYLE = exports.OPTIONS_HAIRLENGTH = exports.OPTIONS_GLASSES = exports.OPTIONS_HAIRCOLOR = exports.OPTIONS_EYECOLOR = exports.OPTIONS_RACE = exports.OPTIONS_SEX = void 0;
exports.OPTIONS_SEX = [
    ['M', 'MALE'],
    ['F', 'FEMALE'],
    ['U', 'UNKNOWN GENDER']
];
exports.OPTIONS_RACE = [
    ['A', 'ASIAN'],
    ['B', 'BLACK'],
    ['W', 'CAUCASIAN/LATINO'],
    ['I', 'NATIVE AMERICAN'],
    ['U', 'UNKNOWN']
];
exports.OPTIONS_EYECOLOR = [
    ['BLK', 'BLACK'],
    ['BLU', 'BLUE'],
    ['BRO', 'BROWN'],
    ['GRN', 'GREEN'],
    ['GRY', 'GRAY'],
    ['HAZ', 'HAZEL'],
    ['MAR', 'MAROON'],
    ['MUL', 'MULTICOLORED'],
    ['PNK', 'PINK'],
    ['XXX', 'UNKNOWN']
];
exports.OPTIONS_HAIRCOLOR = [
    ['BLK', 'BLACK'],
    ['BLN', 'BLOND OR STRAWBERRY'],
    ['BLU', 'BLUE'],
    ['BRO', 'BROWN'],
    ['GRN', 'GREEN'],
    ['GRY', 'GRAY OR PARTIALLY GRAY'],
    ['ONG', 'ORANGE'],
    ['PLE', 'PURPLE'],
    ['PNK', 'PINK'],
    ['RED', 'RED OR AUBURN'],
    ['SDY', 'SANDY'],
    ['WHI', 'WHITE'],
    ['XXX', 'UNKNOWN OR COMPLETELY BALD']
];
//
// Mugshot Physical Characteristics
//
// Note: this is different from the usual'N'/'Y' OPTIONS_YES_NO
exports.OPTIONS_GLASSES = [
    ['NO', 'NO'],
    ['YES', 'YES']
];
exports.OPTIONS_HAIRLENGTH = [
    ['SHT', 'SHORT'],
    ['MED', 'MEDIUM'],
    ['LNG', 'LONG'],
    ['SHL', 'SHOULDER'],
    ['BLD', 'BALD'],
    ['BDG', 'BALDING']
];
exports.OPTIONS_HAIRSTYLE = [
    ['BDG', 'BALDING'],
    ['BRA', 'BRAIDS'],
    ['CLY', 'CURLY'],
    ['DRD', 'DREADLOCKS'],
    ['MOH', 'MOHAWK'],
    ['SHV', 'SHAVED'],
    ['STR', 'STRAIGHT'],
    ['WVY', 'WAVY'],
    ['MUL', 'MULLET'],
    ['SPK', 'SPIKE'],
    ['FOH', 'FOHAWK'],
    ['AFR', 'AFRO'],
    ['TWI', 'TWISTIES']
];
exports.OPTIONS_COMPLEXION = [
    ['ALB', 'ALBINO'],
    ['BLACK', 'BLACK'],
    ['DRK', 'DARK'],
    ['DARK BROWN', 'DARK BROWN'],
    ['FAI', 'FAIR'],
    ['LGT', 'LIGHT'],
    ['LT BROWN', 'LT BROWN'],
    ['MED', 'MEDIUM'],
    ['MD-BROWN', 'MEDIUM BROWN'],
    ['OLV', 'OLIVE'],
    ['RDY', 'RUDDY'],
    ['SLW', 'SALLOW'],
    ['YELLOW', 'YELLOW']
];
exports.OPTIONS_BEARD = [
    ['BRD', 'BEARD'],
    ['GTE', 'GOATEE'],
    ['UNS', 'UNSHAVEN'],
    ['NON', 'NONE']
];
exports.OPTIONS_MUSTACHE = [
    ['HDB', 'HANDLEBAR'],
    ['MST', 'MUSTACHE'],
    ['UNS', 'UNSHAVEN'],
    ['NON', 'NONE'],
    ['FMC', 'FU-MAN-CHU']
];
// Note: this is different from the usual'N'/'Y' OPTIONS_YES_NO
exports.OPTIONS_SIDEBURNS = [
    ['NO', 'NO'],
    ['YES', 'YES']
];
exports.OPTIONS_FACIALHAIR = [
    ['SHT', 'SHORT'],
    ['PAT', 'PATCHY'],
    ['LNG', 'LONG'],
    ['NONE', 'NONE']
];
exports.OPTIONS_BUILD = [
    ['LGT', 'LIGHT'],
    ['MED', 'MEDIUM'],
    ['HVY', 'HEAVY'],
    ['UNK', 'UNKNOWN']
];
//
// These are the Originating Agency Identification codes provided by King County on 20220428
//
exports.OPTIONS_ORICODES = [
    ['WA0170100', 'AUBURN PD'],
    ['WA017013A', 'KING COUNTY PROSECUTING ATTORNEY'],
    ['WA017013J', 'SEATTLE DISTRICT COURT'],
    ['WA017013N', 'VALLEY COMMUNICATIONS'],
    ['WA017015A', "WA STATE ATTORNEY GENERAL'S OFFICE"],
    ['WA017015J', 'KING COUNTY SUPERIOR COURT'],
    ['WA0170200', 'BELLEVUE PD'],
    ['WA017021C', 'SOUTH CORRECTIONAL ENTITY SCORE'],
    ['WA017023C', 'KING COUNTY DEPARTMENT OF YOUTH SERVICES'],
    ['WA017023G', 'KING COUNTY PROBATION'],
    ['WA017023J', 'SOUTHWEST DISTRICT, BURIEN'],
    ['WA0170300', 'BOTHELL PD'],
    ['WA017031A', "SEATTLE CITY ATTORNEY'S OFFICE"],
    ['WA017031J', 'ENUMCLAW MUNICIPAL COURT'],
    ['WA017033C', 'KING CO DEPT ADULT AND JUV DETENTION'],
    ['WA017033J', 'AUKEEN DISTRICT COURT, KENT'],
    ['WA0170400', 'ENUMCLAW PD'],
    ['WA017043J', 'BELLEVUE DISTRICT COURT'],
    ['WA017045J', 'KING COUNTY JUVENILE COURT'],
    ['WA0170600', 'ISSAQUAH PD'],
    ['WA017061A', "CITY ATTORNEY'S OFFICE KENT"],
    ['WA017063J', 'ISSAQUAH DISTRICT COURT'],
    ['WA0170700', 'KENT PD'],
    ['WA0170800', 'KIRKLAND PD'],
    ['WA017083J', 'NORTHEAST DISTRICT COURT, REDMOND'],
    ['WA0170900', 'MERCER ISLAND PD'],
    ['WA017091J', 'PACIFIC MUNICIPAL COURT'],
    ['WA0171000', 'NORMANDY PARK PD'],
    ['WA017101J', 'RENTON MUNICIPAL COURT'],
    ['WA017103J', 'RENTON DISTRICT COURT'],
    ['WA0171100', 'NORTH BEND PD'],
    ['WA017111J', 'KENT MUNICIPAL COURT'],
    ['WA017113J', 'SHORELINE DISTRICT COURT'],
    ['WA0171200', 'REDMOND PD'],
    ['WA017123J', 'SOUTHWEST DISTRICT COURT, VASHON ISLAND'],
    ['WA0171300', 'RENTON PD'],
    ['WA017131J', 'BLACK DIAMOND MUNICIPAL COURT'],
    ['WA0171400', 'ALGONA PD'],
    ['WA017141J', 'DES MOINES MUNICIPAL COURT'],
    ['WA017143J', 'KING COUNTY DISTRICT COURT'],
    ['WA0171500', 'BLACK DIAMOND PD'],
    ['WA017151J', 'LAKE FOREST PARK MUNICIPAL COURT'],
    ['WA0171600', 'CARNATION PD'],
    ['WA0171700', 'DES MOINES PD'],
    ['WA017171J', 'TUKWILA MUNICIPAL COURT'],
    ['WA0171800', 'DUVALL PD'],
    ['WA017181J', 'SKYKOMISH MUNICIPAL COURT'],
    ['WA0172000', 'MEDINA PD'],
    ['WA0172100', 'PACIFIC PD'],
    ['WA0172200', 'SNOQUALMIE PD'],
    ['WA0172300', 'TUKWILA PD'],
    ['WA0172400', 'UNIVERSITY OF WASHINGTON PD'],
    ['WA017241J', 'CARNATION MUNICIPAL COURT'],
    ['WA0172500', 'CLYDE HILL PD'],
    ['WA0172600', 'LAKE FOREST PARK PD'],
    ['WA0172700', 'SKYKOMISH PD'],
    ['WA0172900', 'BEAUX ARTS PD'],
    ['WA0172K1J', 'ISSAQUAH MUNICIPAL COURT'],
    ['WA0172K1J', 'SNOQUALMIE MUNICIPAL COURT'],
    ['WA0173000', 'HUNTS POINT PD'],
    ['WA0173100', 'YARROW POINT PD'],
    ['WA0173200', 'PORT OF SEATTLE PD'],
    ['WA017321J', 'DUVALL MUNICIPAL COURT'],
    ['WA017331J', 'SEATTLE MUNICIPAL COURT'],
    ['WA0173500', 'KC AIRPORT PD'],
    ['WA0173600', 'FEDERAL WAY PD'],
    ['WA0173700', 'SEATAC PD'],
    ['WA0174000', 'WOODINVILLE PD'],
    ['WA0174100', 'BURIEN PD'],
    ['WA0174200', 'NEW CASTLE PD'],
    ['WA0174300', 'SHORELINE PD'],
    ['WA0174500', 'EASTSIDE NARCOTICS TASK FORCE'],
    ['WA0174700', 'MAPLE VALLEY PD'],
    ['WA0174800', 'COVINGTON PD'],
    ['WA0174900', 'KENMORE PD'],
    ['WA0174K1J', 'KIRKLAND MUNICIPAL COURT'],
    ['WA0175000', 'SAMMAMISH PD'],
    ['WA0175K1J', 'BOTHELL MUNICIPAL COURT'],
    ['WA0179J1J', 'SEATAC MUNICIPAL COURT'],
    ['WA0179M1J', 'FEDERAL WAY MUNICIPAL COURT'],
    ['WA017A03N', 'NORCOM'],
    ['WA017A51J', 'MERCER ISLAND MUNICIPAL COURT'],
    ['WA027011J', 'MUNICIPAL COURT BONNEY LAKE'],
    ['WA027013A', 'PIERCE COUNTY PROSECUTORS OFFICE'],
    ['WA027013C', 'PIERCE COUNTY DEPT OF CORRECTIONS'],
    ['WA027013J', 'PIERCE COUNTY DISTRICT COURT NO 1'],
    ['WA0270200', 'SUMNER PD'],
    ['WA027021J', 'MUNICIPAL COURT BUCKLEY'],
    ['WA027035J', 'PIERCE COUNTY JUVENILE COURT'],
    ['WA0270400', 'BUCKLEY PD'],
    ['WA0270500', 'EATONVILLE PD'],
    ['WA027051J', 'MILTON MUNICIPAL COURT'],
    ['WA027061J', 'MUNICIPAL COURT ORTING'],
    ['WA0270700', 'FIFE POLICE DEPARTMENT'],
    ['WA027071J', 'PUYALLUP MUNICIPAL COURT'],
    ['WA0270900', 'MILTON PD'],
    ['WA027091J', 'MUNICIPAL COURT SUMNER'],
    ['WA027101J', 'TACOMA MUNICIPAL COURT'],
    ['WA027111J', 'MUNICIPAL COURT FIFE'],
    ['WA0271300', 'ORTING PD'],
    ['WA0271400', 'BONNEY LAKE PD'],
    ['WA027141J', 'RUSTON MUNICIPAL COURT'],
    ['WA027171J', 'MUNICIPAL COURT EATONVILLE'],
    ['WA027181J', 'SOUTH PRAIRIE MUNICIPAL COURT'],
    ['WA0271900', 'RUSTON PD'],
    ['WA0273000', 'TACOMA PD'],
    ['WA0310300', 'EVERETT PD'],
    ['WA031031J', 'MARYSVILLE MUNICIPAL COURT'],
    ['WA0310400', 'LYNNWOOD PD'],
    ['WA0310500', 'MARYSVILLE PD'],
    ['WA031051J', 'EVERETT MUNICIPAL COURT'],
    ['WA031071J', 'LYNNWOOD MUNICIPAL COURT'],
    ['WA034015A', 'WA STATE ATTORNEY GENERAL OLYMPIA'],
    ['WA034015G', 'WA STATE DEPT OF CORRECTIONS'],
    ['WA0341000', 'WA STATE GAMBLING COMMISSION'],
    ['WA0341100', 'WA ST LIQUOR CONTROL BOARD ENF DIV'],
    ['WA0341600', 'WA DEPT OF NATURAL RESOURCES'],
    ['WA0342000', 'WA DEPT OF PARKS AND RECREATION'],
    ['WA0349900', 'WA DEPT OF FISH AND WILDLIFE'],
    ['WA0370100', 'BELLINGHAM PD'],
    ['WA037011J', 'BELLINGHAM MUNICIPAL COURT'],
    ['WA037021J', 'FERNDALE MUNICIPAL COURT'],
    ['WA037031J', 'LYNDEN MUNICIPAL COURT'],
    ['WA0370400', 'FERNDALE PD'],
    ['WA0370500', 'LYNDEN PD'],
    ['WA920190Z', 'WA STATE HORSE RACING COMMISSION'],
    ['WA920310Z', 'WA STATE TEACHERS AND SCHOOL DISTRICT EMPLOYEES'],
    ['WA920330Z', 'WA STATE DSHS'],
    ['WA920550Z', 'CASA'],
    ['WA920631Z', 'WA STATE DEPARTMENT OF HEALTH'],
    ['WA920657Z', 'KING COUNTY REC/LIC SERVICES'],
    ['WACMV000Z', 'WASHINGTON STATE DEPARTMENT OF LICENSING'],
    ['WACMV001Z', 'WASHINGTON STATE DEPARTMENT OF LICENSING'],
    ['WAD0A0200', 'US FOREST SERVICE LAW ENFORCEMENT GROUP'],
    ['WADI00100', 'MT RAINIER NAT PARK PK RANGER DIV LONGMIRE'],
    ['WAKCS0000', "KING COUNTY SHERIFF'S OFFICE"],
    ['WASPD0000', 'SEATTLE PD'],
    ['WAUSM0100', "US MARSHAL'S SERVICE"],
    ['WAWSP2000', 'WSP DISTRICT 2'],
    ['WA0310100', 'ARLINGTON PD'],
    ['WA0311900', 'LAKE STEVENS PD'],
    ['WA0175400', 'PUGET SOUND REG FIRE AUTHORITY'],
    ['WA0175300', 'SEATTLE FIRE DEPARTMENT INVESTIGATION UNIT'],
    ['WA0150100', 'OAK HARBOR PD'],
    ['WA015013J', 'ISLAND COUNTY DISTRICT COURT'],
    ['WA017T53N', 'SEATTLE COMMUNITY SAFETY AND COMM CENTER'],
    ['WADI06400', 'SWINOMISH TRIBAL PD'],
    ['WADI0011J', 'SWINOMISH TRIBAL COURT']
];
exports.OPTIONS_PLACEOFBIRTH = [
    ['AA', 'ALBANIA'],
    ['AB', 'ALBERTA'],
    ['AD', 'ANDORRA'],
    ['AE', 'ANGUILLA'],
    ['AF', 'AFGHANISTAN'],
    ['AG', 'AGUASCALIENTES'],
    ['AH', 'ASHMORE/CARTIER ISLANDS'],
    ['AI', 'ANTIGUA AND BARBUDA'],
    ['AJ', 'ARUBA'],
    ['AK', 'ALASKA'],
    ['AL', 'ALABAMA'],
    ['AM', 'AMERICAN SAMOA'],
    ['AN', 'ALGERIA'],
    ['AO', 'ANGOLA'],
    ['AP', 'ARMENIA'],
    ['AQ', 'AZORES ISLANDS'],
    ['AR', 'ARKANSAS'],
    ['AS', 'AUSTRALIA'],
    ['AT', 'ARGENTINA'],
    ['AU', 'AUSTRIA'],
    ['AV', 'AZERBAIJAN'],
    ['AX', 'APACHE TRIBE'],
    ['AZ', 'ARIZONA '],
    ['BA', 'BAJA CALIFORNIA NORTHERN'],
    ['BB', 'BARBADOS'],
    ['BC', 'BRITISH COLUMBIA'],
    ['BD', 'BAHAMAS'],
    ['BE', 'BAHRAIN/BAHREIN'],
    ['BF', 'BASSASS DA INDIA'],
    ['BG', 'BELGIUM'],
    ['BH', 'BELIZE'],
    ['BI', 'BURUNDI'],
    ['BJ', 'BAJA CALIFORNIA SOUTHERN'],
    ['BK', 'BAKER ISLAND '],
    ['BL', 'BANGLADESH'],
    ['BM', 'BERMUDA'],
    ['BN', 'BHUTAN'],
    ['BO', 'BRITISH INDIA OCEAN TERR'],
    ['BP', 'BOSNIA AND HERZEGOVINA'],
    ['BQ', 'BOUVET ISLAND'],
    ['BR', 'BURMA'],
    ['BS', 'BRITIAH SOLOMON ISLAND'],
    ['BT', 'BOTSWANA'],
    ['BU', 'BULGARIA'],
    ['BV', 'BOLIVIA'],
    ['BW', 'BALEARIC ISLANDS'],
    ['BX', 'BRUNEI'],
    ['BY', 'BYELARUS'],
    ['BZ', 'BRAZIL'],
    ['CA', 'CALIFORNIA'],
    ['CB', 'COLOMBIA, REPUBLIC OF'],
    ['CC', 'CUBA, REPUBLIC OF'],
    ['CD', 'CANADA'],
    ['CE', 'CAMPECHE'],
    ['CF', 'CHAD'],
    ['CG', 'CAROLINE ISLANDS'],
    ['CH', 'CHIHUAHUA'],
    ['CI', 'CHIAPAS'],
    ['CJ', 'CAMBODIA'],
    ['CK', 'CADDO TRIBE'],
    ['CL', 'COLIMA'],
    ['CM', 'CAMEROON'],
    ['CO', 'COLORADO'],
    ['CP', 'CAYMAN ISLANDS'],
    ['CQ', 'CHILE, REPUBLIC OF'],
    ['CR', 'COSTA RICA, REPUBLIC OF'],
    ['CS', 'CYPRUS, REPUBLIC OF'],
    ['CT', 'CONNECTICUT'],
    ['CU', 'COAHUILA'],
    ['CV', 'CAPE VERDE ISLANDS'],
    ['CW', 'CENTRAL AFRICAN REPUBLIC'],
    ['CY', 'SRI LANKA'],
    ['CZ', 'CANAL ZONE'],
    ['DA', 'CHEYENNE & ARAPAHO TRIBES'],
    ['DB', 'CLIPPERTON ISLAND'],
    ['DC', 'DISTRICT OF COLUMBIA'],
    ['DD', 'COCOS (KEELING) ISLANDS, TERRITORY'],
    ['DE', 'DELAWARE'],
    ['DF', 'DISTRITO FEDERAL'],
    ['DG', 'COMOROSM, FED. ISLAMIC REPUBLIC OF'],
    ['DH', 'BENIN'],
    ['DI', 'COOK ISLANDS'],
    ['DJ', 'CORAL SEA ISLANDS, TERRITORY OF'],
    ['DK', 'DENMARK, KINGDOM OF '],
    ['DL', "DEVIL'S LAKE SIOUX TRIBE"],
    ['DM', 'DOMINICA'],
    ['DN', 'DJIBOUTI, REPUBLIC OF'],
    ['DO', 'DURANGO'],
    ['DP', 'COMANCHE NATION'],
    ['DR', 'DOMINICAN REPUBLIC'],
    ['DS', 'MIAMI TRIBE'],
    ['DT', 'MUCOGEE(CREEK) TRIBE'],
    ['DV', 'SENECA-CAYUGA TRIBES'],
    ['DW', 'CITIZEN BAND POTTAWATOMIE TRIBE'],
    ['EE', 'ABSENTEE SHAWNEE'],
    ['EK', 'EQUATORIAL GUINEA'],
    ['EL', 'EL SALVADOR'],
    ['EN', 'ENGLAND'],
    ['EO', 'ETHIOPIA'],
    ['ER', 'EUROPA ISLAND'],
    ['ES', 'ESTONIA'],
    ['ET', 'ERITREA'],
    ['EU', 'ECUADOR'],
    ['EY', 'EGYPT'],
    ['EZ', 'CZECH REPUBLIC'],
    ['FA', 'FALKLAND ISLANDS, COLONY '],
    ['FC', 'FOND DU LAC'],
    ['FD', 'FINLAND'],
    ['FG', 'FRENCH GUIANA'],
    ['FJ', 'FIJI'],
    ['FL', 'FLORIDA'],
    ['FN', 'FRANCE'],
    ['FO', 'FAROE ISLANDS'],
    ['FP', 'FRENCH POLYNESIA, TERRITORY OF'],
    ['FR', 'FRENCH SOUTHERN AND ANTARCTIC LANDS, TERRITORY OF'],
    ['FS', 'FEDERATED STATES OF MICRONESIA'],
    ['FX', 'SAC & FOX'],
    ['GA', 'GEORGIA'],
    ['GB', 'GABON'],
    ['GC', 'GREECE'],
    ['GD', 'GEORGIA ( FORMARLY GRUZINSKAYA)'],
    ['GE', 'GERMANY'],
    ['GF', 'GUERNSEY, BAILIWIK OF'],
    ['GG', 'GHANA'],
    ['GI', 'GUINEA'],
    ['GJ', 'GRENADA'],
    ['GK', 'GAMBIA, THE'],
    ['GM', 'GUAM'],
    ['GN', 'GREENLAND'],
    ['GO', 'GLORIOSO ISLANDS'],
    ['GP', 'GUADELOUPE, DEPARTMENT OF'],
    ['GR', 'GUERRERO'],
    ['GS', 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS'],
    ['GT', 'GUATEMALA'],
    ['GU', 'GUANAJAUTO'],
    ['GY', 'GUYANA'],
    ['GZ', 'GAZA'],
    ['HD', 'HONDURAS'],
    ['HE', 'HEARD ISLAND AND MCDONAL ISLANDS, TERRITORY OF'],
    ['HI', 'HAWAII'],
    ['HK', 'HONG KONG'],
    ['HL', 'HIDALGO'],
    ['HN', 'VANUATU, REPUBLIC OF'],
    ['HO', 'HOWLAND ISLAND'],
    ['HR', 'CHRISTMAS ISLAND, TERRITORY OF'],
    ['HS', 'SAINT HELENA'],
    ['HT', 'HAITI'],
    ['HU', 'HUNGARY'],
    ['IA', 'IOWA '],
    ['IB', 'ISLE OF MAN'],
    ['IC', 'ICELAND'],
    ['ID', 'IDAHO'],
    ['IE', 'IRELAND(DOES NOT INCLUDE NORTHERN IRELAND)'],
    ['II', 'INDIA'],
    ['IL', 'ILLINOIS'],
    ['IM', 'MADEIRA ISLANDS'],
    ['IN', 'INDIANA'],
    ['IO', 'INDONESIA (NOW INCLUDES PORTUGESE TIMOR)'],
    ['IQ', 'IRAQ'],
    ['IR', 'IRAN'],
    ['IS', 'ISRAEL'],
    ['IT', 'ITALY (INCLUDES SICILY AND SARDINIA)'],
    ['IU', 'NIUE'],
    ['IW', 'IOWA TRIBE'],
    ['IX', 'MENOMINEE'],
    ['IY', "COTE D'IVOIRE (IVORY COAST)"],
    ['JA', 'JAPAN '],
    ['JE', 'JERSEY , BAILIWICK OF'],
    ['JI', 'JOHNSTON ATOLL'],
    ['JL', 'JALISCO'],
    ['JM', 'JAMAICA'],
    ['JN', 'JAN MAYEN'],
    ['JO', 'JORDAN'],
    ['JR', 'JARVIS ISLAND'],
    ['JU', 'JUAN DE NOVA ISLAND'],
    ['KB', 'KIRIBATI'],
    ['KC', 'CROATIA'],
    ['KE', 'KENYA'],
    ['KH', 'MANAHIKI ISLAND'],
    ['KI', 'KINGMAN REEF'],
    ['KK', 'KICKAPOO TRIBE'],
    ['KN', 'NORTH KOREA'],
    ['KO', 'SOUTH KOREA'],
    ['KP', 'SHAKOPEE'],
    ['KS', 'KANSAS'],
    ['KT', 'KAZAKHSTAN'],
    ['KU', 'KUWAIT'],
    ['KV', 'KOSOVO'],
    ['KW', 'KIOWA'],
    ['KY', 'KENTUCKY'],
    ['KZ', 'KYRGYZSTAN'],
    ['LA', 'LOUISIANA'],
    ['LB', 'LIBERIA'],
    ['LC', 'MILLE LACS'],
    ['LD', 'MOLDOVA'],
    ['LE', 'LESOTHO'],
    ['LF', 'SLOVAKIA'],
    ['LH', 'LITHUANIA'],
    ['LI', 'LIECHTENSTEIN'],
    ['LL', 'LEECH LAKE BAND OF CHIPPEWA'],
    ['LN', 'LEBANON'],
    ['LO', 'SLOVENIA'],
    ['LP', 'LAC DU FLAMBEAU-BAND OF SUPERIOR CHIPPEWA'],
    ['LS', 'LAOS'],
    ['LT', 'LATVIA'],
    ['LU', 'SAINT LUCIA'],
    ['LX', 'LUXENBURG'],
    ['LY', 'LIBYA'],
    ['MA', 'MASSACHUSETTES'],
    ['MB', 'MANITOBA (CANADIAN PROVINCE)'],
    ['MC', 'MICHOACAN'],
    ['MD', 'MARYLAND'],
    ['ME', 'MAINE'],
    ['MF', 'MALAWI'],
    ['MG', 'MOGOLIA'],
    ['MH', 'MARSHALL ISLANDS'],
    ['MI', 'MICHIGAN'],
    ['MJ', 'MONACO'],
    ['MK', 'MARIANA ISLANDS'],
    ['ML', 'MALI'],
    ['MM', 'MEXICO (USE ONLY WHEN STATE IS UNKNOWN)'],
    ['MN', 'MINNESOTA'],
    ['MO', 'MISSOURI'],
    ['MP', 'MALAGASY REPUBLIC (INCLUDES MADAGASCAR)'],
    ['MQ', 'MOROCCO'],
    ['MR', 'MORELOS (MEXICAN STATE)'],
    ['MS', 'MISSISSIPPI'],
    ['MT', 'MONTANA'],
    ['MU', 'MAURITANIA'],
    ['MV', 'MALDIVES'],
    ['MW', 'MIDWAY ISLANDS'],
    ['MX', 'MEXICO  '],
    ['MY', 'MALTA'],
    ['MZ', 'MALAYSIA'],
    ['NA', 'NAYARIT'],
    ['NB', 'NEBRASKA'],
    ['NC', 'NORTH CAROLINA'],
    ['ND', 'NORTH DAKOTA'],
    ['NE', 'HOLLAND (NETHERLANDS)'],
    ['NF', 'NEWFOUNDLAND'],
    ['NG', 'NIGERIA'],
    ['NH', 'NEW HAMPSHIRE'],
    ['NI', 'NORTHERN IRELAND'],
    ['NJ', 'NEW JERSEY'],
    ['NK', 'NEW BRUNSWICK ( CANADIAN PROVINCE)'],
    ['NL', 'NUEVO LEON ( MEXICAN STATE)'],
    ['NM', 'NEW MEXICO'],
    ['NN', 'NIGER '],
    ['NO', 'PAPULA NEW GUINEA'],
    ['NP', 'NEPAL'],
    ['NQ', 'NEW CALEDONIA'],
    ['NR', 'NAURU'],
    ['NS', 'NOVA SCOTIA (CANADIAN PROVINCE)'],
    ['NT', 'NORTHWEST TERRITORIES (CANADIAN ADMIN. DIVISION)'],
    ['NU', 'NICARAGUA'],
    ['NV', 'NEVADA'],
    ['NW', 'NORWAY'],
    ['NX', 'NETHERLAND ANTLLES/BONAIRE'],
    ['NY', 'NEW YORK'],
    ['NZ', 'NEW ZEALAND'],
    ['OA', 'OAXACA'],
    ['OC', 'MACAU'],
    ['OF', 'NORFOLK ISLAND, TERRITORY OF'],
    ['OG', 'OSAGE NATION'],
    ['OH', 'OHIO'],
    ['OI', 'OKINAWA'],
    ['OK', 'OKLAHOMA'],
    ['OM', 'OMAN'],
    ['ON', 'ONTARIO'],
    ['OO', 'OTOE-MISSOURIA TRIBE'],
    ['OR', 'OREGON'],
    ['OS', 'OGLALA SIOUX'],
    ['OT', 'ONEIDA TRIBE OF INDIANS IN WISCONSIN'],
    ['PA', 'PENNSYLVANIA'],
    ['PB', 'PUEBLA'],
    ['PC', 'PITCAIRN, HENDERSON, DUCIE, AND OENA ISLANDS'],
    ['PD', 'PALAU, REPUBLIC OF'],
    ['PE', 'PRINCE EDWARD ISLAND'],
    ['PF', 'PARACEL ISLANDS'],
    ['PG', 'GUINEA-BISSAU'],
    ['PI', 'PHILLIPINES'],
    ['PK', 'PAKISTAN'],
    ['PL', 'PALMYRA ATOLL'],
    ['PM', 'PANAMA'],
    ['PN', 'PONCA TRIBE'],
    ['PO', 'POLAND'],
    ['PQ', 'QUEBEC'],
    ['PR', 'PUERTO RICO'],
    ['PS', 'SAINT PIRRE AND MIQUELON, TERRITORIAL COLLECTIVITY OF'],
    ['PT', 'PORTUGAL'],
    ['PU', 'PERU'],
    ['PV', 'PARAGUAY'],
    ['PW', 'PAWNEE TRIBE'],
    ['QA', 'QATAR'],
    ['QR', 'QUINTANA ROO'],
    ['QU', 'QUERETARO'],
    ['RA', 'RUSSIA'],
    ['RB', 'REPUBLIC OF CONGO, BRAZZAVILLE'],
    ['RC', "PEOPLE'S REPUBLIC OF CHINA"],
    ['RE', 'REUNION, DEPARTMENT OF'],
    ['RF', 'RUSSIA FEDERATION'],
    ['RG', 'GIBRALTAR'],
    ['RH', 'ZIMBABWE, REPUBLIC OF'],
    ['RI', 'RHODE ISLAND '],
    ['RL', 'RED LAKE'],
    ['RR', 'MONTSERRAT'],
    ['RS', 'WESTERN SAHARA, INDEPENDENT STATE OF'],
    ['RU', 'ROMANIA/RUMANIA'],
    ['RV', 'SOCIALIST REPUBLIC OF VIETNAM'],
    ['RW', 'RWANDA'],
    ['RY', 'REPUBLIC OF YEMEN'],
    ['SA', 'SIERRA LEONE'],
    ['SB', 'SAUDI ARABIA'],
    ['SC', 'SOUTH CAROLINA'],
    ['SD', 'SOUTH DAKOTA'],
    ['SE', 'SEYCHELLES'],
    ['SF', 'SOUTH AFRICA'],
    ['SG', 'SENEGAL'],
    ['SH', 'SAN MARINO'],
    ['SI', 'SINALOA'],
    ['SJ', 'NAMIBIA( SOUTH WEST AFRICA)'],
    ['SK', 'SEMINOLE NATION'],
    ['SL', 'SAN LUIS POTOSI'],
    ['SM', 'SOMALIA'],
    ['SN', 'SASKATCHEWAN'],
    ['SO', 'SONORA'],
    ['SP', 'SPAIN '],
    ['SQ', 'SWEDEN'],
    ['SR', 'SINGAPORE'],
    ['SS', 'SCOTLAND'],
    ['SU', 'SUDAN'],
    ['SV', 'SVALBARD'],
    ['SW', 'SWAZILAND'],
    ['SY', 'SYRIA'],
    ['SZ', 'SWITZERLAND'],
    ['TA', 'TAMAULIPAS'],
    ['TB', 'TABASCO'],
    ['TC', 'UNITED ARAB EMIRATES (FORMERLY TRUCIAL STATES)'],
    ['TD', 'TRUST TERRITORY OF THE PACIFIC I'],
    ['TE', 'SPRATLY ISLAND'],
    ['TF', 'TUAMOTU ARCHIPELAGO'],
    ['TG', 'TONGA'],
    ['TH', 'THAILAND'],
    ['TJ', 'TAJIKISTAN'],
    ['TK', 'TOKELAU'],
    ['TL', 'TLAXCALA'],
    ['TM', 'TROMELIN ISLAND (FRENCH POSSESSION)'],
    ['TN', 'TENNESSEE'],
    ['TO', 'TOGO'],
    ['TP', 'SAO TOME AND PRINCIPE'],
    ['TQ', 'TONGAREVA'],
    ['TR', 'TURKS AND CAICO ISLANDS'],
    ['TS', 'NEVIS AND SIANT CHRISTOPHER (SAINT KITTS)'],
    ['TT', 'TRINIDAD AND TOBAGO'],
    ['TU', 'TUNISIA'],
    ['TV', 'TUVALU'],
    ['TW', 'TAIWAN, REPUBLIC OF CHINA'],
    ['TX', 'TEXAS'],
    ['TY', 'TURKEY'],
    ['TZ', 'TANZANIA, UNITED REPUBLIC OF'],
    ['UC', 'TURTLE MOUNTAIN BAND OF CHIPEWA'],
    ['UG', 'UGANDA'],
    ['UK', 'UKRAINE'],
    ['UM', 'MAURITIUS'],
    ['UN', 'UNITED KINGDOM'],
    ['UR', 'TURKMENISTAN'],
    ['UT', 'UTAH'],
    ['UV', 'BURKINA FASO'],
    ['UY', 'URUGUAY'],
    ['UZ', 'UZBEKISTAN, REPUBLIC OF'],
    ['VA', 'VIRGINIA'],
    ['VB', 'BRITISH VIRGIN ISLANDS'],
    ['VC', 'VERACRUZ'],
    ['VI', 'VIRGIN ISLANDS (U.S.)'],
    ['VL', 'NAVASSA ISLAND'],
    ['VT', 'VERMONT'],
    ['VV', 'SAINT VINCENT AND THE GRENADINES'],
    ['VY', 'VATICAN CITY'],
    ['VZ', 'VENEZUELA, REPUBLIC OF'],
    ['WA', 'WASHINGTON'],
    ['WB', 'WEST BANK'],
    ['WD', 'WYANDOTTE TRIBE'],
    ['WE', 'WHITE EARTH'],
    ['WF', 'WALLIS AND FUTUNA, TERRITORY'],
    ['WI', 'WISCONSIN'],
    ['WK', 'WAKE ISLAND'],
    ['WL', 'WALES'],
    ['WN', 'WEST INDIES-FOR WEST INDIES ISLANDS NOT LISTED'],
    ['WS', 'WESTERN SAMOA'],
    ['WT', 'WICHITA TRIBE'],
    ['WV', 'WEST VIRGINIA'],
    ['WY', 'WYOMING'],
    ['YG', 'YUGOSLAVIA'],
    ['YO', 'MAYOTTE'],
    ['YT', 'YUKON (TERRITORY)'],
    ['YU', 'YUCATAN'],
    ['ZA', 'ZACATECAS'],
    ['ZB', 'MARTINIQUE'],
    ['ZC', 'SURINAM'],
    ['ZD', 'MACEDONIA'],
    ['ZI', 'CANARY ISLANDS'],
    ['ZM', 'ZAMBIA, REPUBLIC OF'],
    ['ZO', 'MOZAMBIQUE'],
    ['ZR', 'ZAIRE, REPUBLIC OF'],
    ['XB', 'MONTENEGRO'],
    ['XA', 'SERBIA'],
    ['XX', 'UNKNOWN PLACE OF BIRTH '],
    ['YY', 'USE FOR ANY COUNTRY/DEPENDENCY/TERRITORY NOT INCLUDED']
];
//# sourceMappingURL=option-lists.js.map